import { Feature } from '@tencent/workbench';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { IChartLegendFeature } from '@tencent/chart-drawer-components/lib/interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { legendPositionMapping } from '../utils';
import type { ILegendPos } from '@tencent/chart-drawer-components/lib/interface';

@Feature({
    name: 'ChartLegendFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartLegendFeature,
})
export class ChartLegendFeature extends ChartBaseDrawerFeature implements IChartLegendFeature {
    public setLegendPosition(position: ILegendPos) {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return;
        const legendProperty = model.chartProperty.legend;
        // 设置位置的时候，需要清除自定义layout
        legendProperty?.updateProps({ position: legendPositionMapping[position] }, { layout: null });
    }
}
